import { render, staticRenderFns } from "./BGASelect.vue?vue&type=template&id=d3f13e14&scoped=true&"
import script from "./BGASelect.vue?vue&type=script&lang=js&"
export * from "./BGASelect.vue?vue&type=script&lang=js&"
import style0 from "./BGASelect.vue?vue&type=style&index=0&id=d3f13e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f13e14",
  null
  
)

export default component.exports